module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('App-SideMenu'), _vm._v(" "), _c('main', {
    staticClass: "cd-main-content"
  }, [_c('div', {
    staticClass: "landing-main-content"
  }, [_c('div', {
    staticClass: "book-bg"
  }, [_c('div', {
    staticClass: "pl-bg-gradientz"
  }, [_c('div', {
    staticClass: "wrapper-square"
  }, [_c('form', {
    staticClass: "login-form-wrapper"
  }, [_c('div', {
    staticClass: "login-form-content"
  }, [_c('h1', [_vm._v("Sign In")]), _vm._v(" "), _c('div', {
    staticClass: "login-input-containers"
  }, [_c('h3', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("EMAIL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "texts",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "red fs-12 block"
  }, [_vm._v(_vm._s(_vm.usernameErrorMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "login-input-containers"
  }, [_c('h3', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("PASSWORD")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "red fs-12 block"
  }, [_vm._v(_vm._s(_vm.passwordErrorMessage))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "pointer",
    attrs: {
      "id": "login-register-btn"
    },
    on: {
      "click": function($event) {
        _vm.handleSignIn()
      }
    }
  }, [_vm._v("Sign In")]), _vm._v(" "), _vm._m(0, false, false)])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login-signup-link"
    }
  }, [_c('h3', [_vm._v("Use Serambi Ilmu Rakyat Account ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07d39090"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/login.vue
// module id = 1688
// module chunks = 1